document.addEventListener('DOMContentLoaded',function(){
  var astmImg = document.querySelector(".astm-img");
  var galileo_cancel = document.querySelector(".galileo-cancel");
  var galileoImg = document.querySelector(".galileoImg");
  var galileo_astm = document.querySelector("#galileo-astm");
  var GalileoBtn = document.getElementById("GalileoBtn");
  GalileoBtn.addEventListener("click",function(){
    galileo_astm.style.display = "block";
  });
    galileo_cancel.addEventListener("click",function(e){
    galileo_astm.style.display = "none";
  })
    galileoImg.addEventListener("click",function(event){
      event.stopPropagation();
  });

    var fdacontainer = document.querySelector("#fda-container");
  var fdaBtn = document.querySelector("#fdaBtn");
  var fdacancer = document.querySelector(".fda-cancel");
  fdaBtn.addEventListener("click",function(){
    fdacontainer.style.display = "block";
  })
  fdacancer.addEventListener("click",function(){
    fdacontainer.style.display = "none";
  })
  fdacancer.addEventListener("click",function(event){
      event.stopPropagation();
  });

})